<script>
  import { featuretteItems } from '../language/pageContent';
</script>

<!-- START THE FEATURETTES -->

{#each featuretteItems as { heading, muted, placeholder, img, descImg }, i}
  {#if i}
    <hr class="featurette-divider" />
  {/if}
  <div class="row featurette">
    <div class={`col-md-7${i % 2 ? ' order-md-2' : ''}`}>
      <h2 class="featurette-heading">
        {heading} <span class="text-muted">{muted}</span>
      </h2>
      <p class="lead">{placeholder}</p>
    </div>
    <div class={`col-md-5${i % 2 ? ' order-md-1' : ''}`}>
      <img
        width="500"
        height="500"
        src={img}
        alt={descImg}
        class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto"
      />
      <!-- <svg class="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto" width="500" height="500" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 500x500" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#eee"></rect><text x="50%" y="50%" fill="#aaa" dy=".3em">500x500</text></svg> -->
    </div>
  </div>
{/each}

<!-- /END THE FEATURETTES -->
<style>
  .bd-placeholder-img {
    font-size: 1.125rem;
    text-anchor: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }

  @media (min-width: 768px) {
    .bd-placeholder-img-lg {
      font-size: 3.5rem;
    }
  }
</style>
